import { I18n } from "@assets/strings";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useServices } from "@core/servicesContext";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { useParticipants } from "@domain/livecourse/hooks";
import { Livecourse, LivecourseStatus, LivecourseType } from "@domain/livecourse/livecourse";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { AlreadyJoinButton } from "@ui/pages/livecourses/livecoursesThumbnail";
import { createToast } from "@ui/toasts/utils";

interface JoinButtonProps extends React.HTMLAttributes<HTMLButtonElement> {
	livecourse: Livecourse;
}
export const JoinLiveButton: React.FC<JoinButtonProps> = ({ livecourse }) => {
	const { livecourseService, trackingService } = useServices();
	const [joined, setJoined] = useState(false);
	const currentProfile = useCurrentProfile();
	const { result: members, fetch } = useParticipants(livecourse.id);
	const [isCreator, setIsCreator] = useState(currentProfile && currentProfile.id === livecourse.organizer);
	const type: LivecourseType = livecourse.type;

	useEffect(() => {
		{
			const joined = !!currentProfile && members.map((mb) => mb.id).includes(currentProfile.id);

			setJoined(joined);
			setIsCreator(currentProfile && currentProfile.id === livecourse.organizer);
		}
	}, [currentProfile, members]);

	return !isCreator ? (
		joined && type === LivecourseType.INSTANT ? (
			<JoinButton>
				<PrimaryButton
					onClick={async () => {
						await trackingService.track("Classroom - join request");
						global.window.location.href = livecourse.participationLink;
					}}
				>
					{I18n.t("live.join")}
				</PrimaryButton>
			</JoinButton>
		) : joined && type === LivecourseType.SCHEDULED ? (
			<AlreadyJoinButton>{I18n.t("live.confirmed")}</AlreadyJoinButton>
		) : joined && livecourse.status === LivecourseStatus.STATUS ? (
			<AlreadyJoinButton style={{ backgroundColor: "grey" }}>{I18n.t("live.closed")}</AlreadyJoinButton>
		) : !joined ? (
			<JoinButton>
				<PrimaryButton
					onClick={async () => {
						try {
							const { participationLink } = await livecourseService.confirm(livecourse.id);
							createToast(I18n.t("success"), I18n.t("live.confirmed"), "success");
							setJoined(true);
							fetch();
							if (type === LivecourseType.INSTANT && participationLink) global.window.location.href = participationLink;
						} catch {
							createToast(I18n.t("errormessage"), I18n.t("live.declined"), "error");
						}
					}}
				>
					{type === LivecourseType.INSTANT ? I18n.t("live.join") : I18n.t("live.joininstantroom")}
				</PrimaryButton>
			</JoinButton>
		) : (
			<></>
		)
	) : (
		<JoinButton>
			<PrimaryButton
				onClick={async () => {
					const { participationLink } = await livecourseService.confirm(livecourse.id);
					if (participationLink) global.window.location.href = participationLink;
					else createToast(I18n.t("errormessage"), "error", "error");
				}}
			>
				{livecourse.status === LivecourseStatus.STATUS ? I18n.t("live.closed") : I18n.t("live.joinascreator")}
			</PrimaryButton>
		</JoinButton>
	);
};

const JoinButton = styled.div`
	position: relative;
	font-family: Sora;
	margin-top: 12px;
	${({ theme }) => theme.colors.primary};
	font-size: 13px;
	font-weight: 100;
	justify-content: center;
	align-items: center;
`;

// export const AlreadyJoinButton = styled(DefaultButton)`
// 	position: relative;
// 	margin-top: 10px;
// 	font-family: Sora;
// 	background-color: #10c374;
// 	color: white;
// 	width: 270px;
// 	cursor: not-allowed;
// 	:hover {
// 		background-color: #10c374;
// 	}
// `;
